"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PERMISSIONS = exports.PATIENT_STATES = exports.DEFAULT_INDICATORS = void 0;
exports.DEFAULT_INDICATORS = [
    'activity',
    'bloodpressure',
    'bloodsugar',
    'bodytemperature',
    'bloodoxygen',
    'weight',
];
exports.PATIENT_STATES = [
    'new',
    'consented',
    'waiting-for-onboarding',
    'on-boarded',
    'active-care',
    'maintenance',
    'discharged',
    'inactive',
];
exports.PERMISSIONS = [
    'devices',
    'resources',
    'manage',
    'personal',
    'urgencycontacts',
    'contacts',
    'device',
    'atouchaway',
    'reminders',
    'files',
    'forms',
    'groupForms',
];
//# sourceMappingURL=index.js.map